var _hmt = _hmt || [];
(function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?c569550b13eacfdc2c7114c396daa8bf";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();


// WEBPACK FOOTER //
// ./src/utils/visits.js